import { render } from "./image-viewer.vue?vue&type=template&id=58c45684&scoped=true"
import script from "./image-viewer.vue?vue&type=script&lang=js"
export * from "./image-viewer.vue?vue&type=script&lang=js"

import "./image-viewer.vue?vue&type=style&index=0&id=58c45684&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58c45684"

export default script